<script>
import { get as _get, cloneDeep } from 'lodash'
import BScroll from 'better-scroll'
import { washKeys } from 'base/config'
import { formatTenThousand } from 'common/js/format'
import { getScreenSize, getElementTop } from 'common/js/dom'
import ToggleDesc from 'components/toggleDesc/toggleDesc'

const STATE_KEY = 'WeiyiStat_pb_guide'
// 需要显示每日保费的计划书标签序号
const PB_DAILY_TAG = [1, 2, 4, 10]

export default {
  components: {
    ToggleDesc,
  },
  filters: {
    sexStrFilter(value) {
      return value.sex === 2 ? '女' : '男'
    },
  },
  props: {
    personData: {
      type: Object,
      default() {
        return {}
      },
    },
    tableData: {
      type: Array,
      default() {
        return []
      },
    },
    commonData: {
      type: Object,
      default() {
        return {}
      },
    },
    totalBaof: {
      type: Number,
      default: 0,
    },
    isPolicy: {
      type: Boolean,
      default: false,
    },
    tagList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showGuide: false,
      showInsTable: false,
      main: null,
      person: null,
      instable: [],
      leftIconVisible: false,
      rightIconVisible: true,
    }
  },
  computed: {
    onlyInsured() {
      const { person, otperson } = this
      return (
        person &&
        otperson.len === 1 &&
        (!otperson.applicantInfo || !otperson.applicantInfo.title) &&
        (!otperson.spouseInfo || !otperson.spouseInfo.title)
      )
    },
    instableRenderList() {
      const { showInsTable, instable } = this
      if (showInsTable) return instable
      return instable.filter((item, index) => {
        return index < 3
      })
    },
    dailyVisible () {
      const { tagList, totalBaof } = this
      let flag = false
      if (!Array.isArray(tagList)) return
      for (let i = 0, j = PB_DAILY_TAG.length; i < j; i++) {
        if (tagList.indexOf(PB_DAILY_TAG[i]) > -1) {
          flag = true
          break
        }
      }
      return flag && totalBaof && totalBaof <= 10000
    }
  },
  created() {
    const _person = JSON.parse(JSON.stringify(this.personData))
    this.person = _person.insuredInfo
    this.otperson = _person
    this.main = this.washMain(_person.main)
    const screenSize = (this.screenSize = getScreenSize())
    const windowWidth = screenSize.width
    const rate = windowWidth / 375
    const width = windowWidth * 0.952 - 36 * rate
    const baseCellWidth = width * 0.3216
    this.cellWidth = [
      baseCellWidth,
      width * 0.19,
      width * 0.2814,
      width * 0.207,
    ]
    const showTableData = this.tableData.filter((item) => {
      return !item.resultFormulaRef
    })
    const headData = this.washHead(showTableData)
    const instable = this.fillTable(headData, showTableData)
    this.instable = instable
    const moreCellCount = (this.moreCellCount = instable[0].length - 4)
    const moreCellWidth = moreCellCount * baseCellWidth
    this.rowWidth = width + moreCellWidth
    this.minX = 0
    this.maxX = -Math.ceil(moreCellWidth) + 10
    this.rightIconVisible = moreCellCount > 0

    setTimeout(() => {
      this._initScroll()
    }, 20)
  },
  mounted() {
    // const stateKey = localStorage.getItem(STATE_KEY)
    // 引导 - 去掉
    // if (stateKey != 1 && this.moreCellCount > 0) {
    //   this.guideInit()
    // }
  },
  methods: {
    syncToggle() {
      const visible = !this.showInsTable
      this.showInsTable = visible
      this.toggle(visible)
      this.syncDelta && this.syncDelta({ pbData: { isOverviewShow: visible } })
    },
    toggle(visible) {
      this.showInsTable = visible
    },
    washMain(data) {
      let ret = Object.assign({}, data)
      for (let key in ret) {
        if (washKeys.indexOf(key) > -1) {
          ret[key] = ('' + ret[key]).replace(/\d+.\d+|\d+/, '<span>$&</span>')

          // --fix--
          if (key === 'baoeDesc') {
            const _baoe = parseFloat(ret[key])
            if (!isNaN(_baoe) && typeof _baoe === 'number') {
              ret[key] = `${ret[key]}元`
            }
          }
        }
      }
      return ret
    },
    _initScroll() {
      if (!this.$refs.wrapper) return
      this.scroll = new BScroll(this.$refs.wrapper, {
        scrollX: true,
        eventPassthrough: 'vertical',
        probeType: 3,
        click: true,
      })
      this.scroll.on('scroll', (pos) => {
        this.leftIconVisible = pos.x < this.minX
        this.rightIconVisible = pos.x >= this.maxX
      })
      if (this.rightIconVisible) this.$refs.wrapper.children[0].className += ' fd-v2-mv'
    },
    washHead(list) {
      const { commonData } = this
      const heads = []
      const insuranceList = cloneDeep(list)
      for (let key in commonData) {
        if (commonData[key] && commonData[key].eleOrderInResult) {
          insuranceList.push(commonData[key])
        }
      }
      insuranceList
        .filter((item) => Array.isArray(item.eleOrderInResult))
        .forEach((item) => {
          item.eleOrderInResult.forEach((el) => {
            if (!heads.some(e => e.value === el.value && (!e.value.match(/^extra/) || (e.label === el.label)))) {
              heads.push(el)
            }
          })
        })
      return heads
    },
    fillTable(headData, showList) {
      const { commonData, personData, cellWidth } = this
      const _washKeys = ['name', 'baoe', 'iDuration', 'pPeriod', 'baof']
      const names = ['投保险种', '保额', '保险期/交费期', '首年保费']
      const addHeadData = headData.filter((item) => !_washKeys.includes(item.value))
      const rowList = Array.from({ length: showList.length }, () => [])
      const insuredAge = personData.insuredInfo.age
      showList.forEach((ins, index) => {
        let newInsureDetail
        addHeadData.forEach((item) => {
          const { value, label } = item
          let desc = ins[`${value}Desc`] || ins[value] || '-'
          if (value.match(/^extra/)) {
            const _eleOrderInResult = (_get(ins, 'eleOrderInResult', []) || []).concat(_get(commonData, `[${ins.productKey}].eleOrderInResult`, []) || [])
            if (!_eleOrderInResult.some(e => e.value === value && e.label === label )) {
              desc = '-'
            }
          }
          rowList[index].push(desc)

          // 续保 isNewInsure 在首年保费显示
          if (
            (!!ins.isNewInsure || ins.canRenewFlag) &&
            ins.maxAge > insuredAge
          ) {
            newInsureDetail = this.newInsureDetail(ins, addHeadData)
          }
          cellWidth.push(cellWidth[0])
        })
        // 上传费率中无续保但配置续保
        if (!addHeadData.length && ins.canRenewFlag && ins.maxAge > insuredAge) {
          newInsureDetail = this.newInsureDetail(ins, addHeadData)
        }
        let baoeDp = formatTenThousand(ins.baoeDesc || ins.baoe) || '-'
        if (!ins.calMethod) {
          if (ins.showPlanDesc) {
            baoeDp = ins.planDesc
          } else if (ins.showPlanDesc === 'undefined') {
            // planDesc 存在且不等于 plan 显示
            if (ins.planDesc && ins.planDesc != ins.plan) {
              baoeDp = ins.planDesc
            }
          }
        }
        let baofDp = ins.baofDesc || ins.baof || '-'
        const baseRow = [
          ins['name'],
          baoeDp,
          `${ins.iDurationDesc ? ins.iDurationDesc : '-'}/${
            ins.pPeriodDesc ? ins.pPeriodDesc : '-'
          }`,
          newInsureDetail ? [baofDp, newInsureDetail] : baofDp,
        ]
        rowList[index] = baseRow.concat(rowList[index])
      })
      rowList.unshift(names.concat(addHeadData.map(e => e.label)))
      return rowList
    },
    guideInit() {
      const rate = this.screenSize.width / 375
      let BANNER_HEIGHT = 160
      const OFFSET_HEIGHT = 23
      const staticBanner = document.querySelector('.bn-wrap')
      if (staticBanner) {
        BANNER_HEIGHT *= rate
      }
      const targetNode = this.$refs.instableCon
      const top = getElementTop(targetNode)
      const height = BANNER_HEIGHT - OFFSET_HEIGHT + targetNode.offsetTop
      const topOffset = Math.max(top, height)
      const cloneNode = targetNode.cloneNode(true)
      const cloneNodeHeight = Math.min(targetNode.offsetHeight, 200)
      cloneNode.style.top = `${topOffset}px`
      const wrapNode = document.createElement('div')
      wrapNode.className = 'guide-wrapper'
      wrapNode.addEventListener('touchmove', (e) => {
        e.preventDefault()
      })
      wrapNode.addEventListener('click', () => {
        wrapNode.style.display = 'none'
      })
      const tipsNode = document.createElement('div')
      tipsNode.className = 'tips'
      const titleNode = document.createElement('p')
      titleNode.innerText = '左右滑动查看更多投保条件'
      const image = new Image()
      image.src =
        '//media.winbaoxian.com/autoUpload/planbook/arrow_05c82bf958633df.png'
      const btnNode = document.createElement('div')
      btnNode.className = 'btn'
      btnNode.innerText = '知道了'
      btnNode.style.top = `${topOffset + cloneNodeHeight}px`
      tipsNode.appendChild(titleNode)
      tipsNode.appendChild(image)
      wrapNode.appendChild(tipsNode)
      wrapNode.appendChild(cloneNode)
      wrapNode.appendChild(btnNode)
      document.body.append(wrapNode)
      localStorage.setItem(STATE_KEY, 1)
    },
    newInsureDetail(ins, addHeadData) {
      const addHead = addHeadData.filter((item) => {
        return item.value !== 'isNewInsure'
      })
      const head = addHead.map(({ label, value }) => {
        return {
          label,
          value: ins[`${value}Desc`] || ins[value] || '-',
        }
      })
      const baseHead = [
        {
          label: '险种名称',
          value: ins.name,
        },
        {
          label: '保险期间',
          value: ins.iDurationDesc,
        },
        {
          label: '交费期间',
          value: ins.pPeriodDesc,
        },
      ]
      return {
        insuranceId: ins.key,
        conditions: baseHead.concat(head),
      }
    },
    handleNewInsureDetail(value) {
      this.$emit('new-insure-detail', value)
      // TODO: 同步
    },
  },
}
</script>

<template>
  <div class="person person-v2">
    <div
      v-if="!isPolicy"
      class="insured-total"
      :class="{
        'insured-peoples':
          (otperson.applicantInfo && otperson.applicantInfo.title) ||
          (otperson.spouseInfo && otperson.spouseInfo.title),
      }"
    >
      <template v-if="onlyInsured">
        <div class="item cell-box">
          <div class="cell-hd">
            被保人
          </div>
          <div class="cell-bd">
            {{ person | sexStrFilter }}{{ person.age }}
          </div>
        </div>
        <div class="item cell-box">
          <div class="cell-hd">
            保险期间
          </div>
          <div class="cell-bd" v-html="main.iDurationDesc" />
        </div>
        <div class="item cell-box">
          <div class="cell-hd">
            交费期间
          </div>
          <div class="cell-bd" v-html="main.pPeriodDesc" />
        </div>
      </template>
      <template v-else>
        <div
          v-if="otperson.insuredInfo && otperson.insuredInfo.title"
          class="item cell-box"
        >
          <div class="cell-hd">
            被保人
          </div>
          <div class="cell-bd">
            <span>{{ otperson.insuredInfo | sexStrFilter
            }}{{ otperson.insuredInfo.age || 0 }}岁</span>
          </div>
        </div>
        <div
          v-if="otperson.applicantInfo && otperson.applicantInfo.title"
          class="item cell-box"
        >
          <div class="cell-hd">
            投保人
          </div>
          <div class="cell-bd">
            <span>{{ otperson.applicantInfo | sexStrFilter
            }}{{ otperson.applicantInfo.age || 0 }}岁</span>
          </div>
        </div>
        <div
          v-if="otperson.spouseInfo && otperson.spouseInfo.title"
          class="item cell-box"
        >
          <div class="cell-hd">
            配偶
          </div>
          <div class="cell-bd">
            <span>{{ otperson.spouseInfo | sexStrFilter
            }}{{ otperson.spouseInfo.age || 0 }}岁</span>
          </div>
        </div>
      </template>

      <div class="item cell-box">
        <div class="cell-hd">
          首年保费
        </div>
        <div
          v-if="totalBaof || totalBaof === 0"
          key="totalbaof"
          class="cell-bd"
        >
          <span v-html="totalBaof + '元'" />
        </div>
        <div v-else key="totalbaof" class="cell-bd">
          <span v-html="main.baofDesc + '元'" />
        </div>
      </div>
    </div>

    <div ref="instableCon" class="fd" :class="{ more: instable.length > 3 }">
      <div v-if="leftIconVisible" class="iconfont icon-arrows_left" />
      <div v-if="rightIconVisible" class="iconfont icon-arrows_right" />
      <div ref="wrapper" class="instable-wrapper">
        <div class="instable" :style="{ width: `${rowWidth}px` }">
          <div
            v-for="(row, index) in instableRenderList"
            :key="index"
            class="row after-bd-b"
          >
            <div
              v-for="(cell, idx) in row"
              :key="idx"
              class="cell after-bd-r"
              :style="`width: ${cellWidth[idx]}px; ${index === 0 && idx === 0 ? 'display: flex;align-items: center;' : ''}`"
              :class="{
                'text-justify':
                  idx == 0 && Array.isArray(cell) && cell.length >= 7,
              }"
            >
              <span v-if="!Array.isArray(cell)">{{ cell }}</span>
              <div v-else class="new-insure-detail">
                <p>{{ cell[0] }}</p>
                <p>
                  <a
                    href="javascript:;"
                    data-stat-id="xbfl"
                    @click="handleNewInsureDetail(cell[1], index)"
                  >续保保费</a><i class="iconfont icon-arrows_right" style="background: none" />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="dailyVisible" class="person-every-day">
        平均每天约{{ (totalBaof / 365).toFixed(2) }}元，拥有一份安心保障
      </div>
      <toggle-desc
        v-if="instable.length > 3"
        class="toggle-table person_detail"
        @toggle="syncToggle"
      >
        <template v-if="showInsTable">
          <span>收起</span>
          <i class="iconfont icon-arrows_up" />
        </template>
        <template v-else>
          <span>展开详情</span>
          <i class="iconfont icon-arrows_down" />
        </template>
      </toggle-desc>
    </div>
  </div>
</template>

<style lang="postcss">
@import 'variable.css';
.person {
  z-index: 2;
  position: relative;
  @apply --box;
  @apply --widthcenter;
  margin-bottom: 0.2rem;
  padding-top: 0.45rem;

  .text-justify {
    text-align: justify;
  }

  .insured-total {
    display: flex;
    padding: 0 0.3rem 0.22rem;
    text-align: center;
    .item {
      flex: 1;
      flex-direction: column;
      justify-content: center;
      & span {
        color: var(--theme-primary-color);
      }
      &:last-child {
        span {
          white-space: nowrap;
        }
      }
    }
    .cell-hd {
      color: var(--patch-color-text);
      font-size: 0.26rem;
      line-height: 0.4rem;
      margin-bottom: 0.06rem;
    }
    .cell-bd {
      font-size: 0.3rem;
      line-height: 0.42rem;
      font-weight: 500;
    }
    &.insured-peoples {
      .cell-bd {
        font-size: 0.3rem;
      }
    }
  }

  .fd {
    position: relative;
    padding-bottom: 0.23rem;
    margin-top: 0.04rem;
    overflow: hidden;

    .icon-arrows_left,
    .icon-arrows_right {
      z-index: 1;
      position: absolute;
      top: 50%;
      margin-top: -0.5rem;
      display: block;
      color: var(--theme-primary-color);
      font-weight: bold;
      
      border-radius: 50%;
      background: var(--theme-minor-bg);
    }
    .icon-arrows_left {
      left: 0;
      padding: 0.14rem 0.02rem 0.14rem 0.31rem;
      transform: translate(-50%, 0);
      background: var(--theme-minor-bg);
    }
    .icon-arrows_right {
      right: 0;
      padding: 0.14rem 0.31rem 0.14rem 0.02rem;
      transform: translate(50%, 0);
      background: var(--theme-minor-bg);
    }

    & .person_detail {
      color: var(--theme-primary-color);
      & .icon-arrows_down {
        margin-left: 4px;
      }
    }
  }

  .toggle-table {
    padding: 0.24rem 0 0;
    margin: 0 0.3rem;
    box-sizing: content-box;
    outline: 0;
    color: #333;
    > span {
      font-size: 0.26rem;
      vertical-align: middle;
    }
    > i {
      font-size: 16px;
      vertical-align: middle;
    }
  }
}

.instable-wrapper {
  position: relative;
  overflow: hidden;
  margin: 0 0.36rem;
}

.instable {
  margin: 0 auto;
  &:before {
    @apply --bd-w;
    background-color: #e5e5e5;
    left: 0;
    top: 0;
  }
  &:after {
    @apply --bd-h;
    background-color: #e5e5e5;
    left: 0;
    top: 0;
  }
  .row {
    overflow: hidden;
    display: flex;
    .cell {
      float: left;
      min-height: 0.68rem;
      padding: 0.3rem 0.12rem;
      font-size: 0.26rem;
      text-align: left;
      word-break: break-all;
      align-items: center;
      justify-content: center;
      /* white-space: nowrap; */
      &:first-child {
        text-align: left;
      }
      &:not(:first-child) {
        display: flex;
      }
    }
    &:first-child {
      .cell {
        padding: 0.15rem 0;
        min-height: 0.6rem;
        text-align: center;
        background: #f8f8f8;
      }
    }
  }
}

.new-insure-detail {
  text-align: center;
  a {
    color: var(--primary-color);
  }
  p {
    white-space: nowrap;
  }
  .iconfont {
    font-size: 0.24rem;
    color: var(--primary-color) !important;
  }
}
</style>
